import { useTranslation } from "react-i18next";

const Maintenance = () => {
  const { t } = useTranslation();

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}>🛠️</div>
        <h1 style={styles.title}>{t("maintenance.title")}</h1>
        <p style={styles.message}>{t("maintenance.message")}</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    paddingTop: "calc(25vh + 100px)",
    backgroundImage: "url(/background_urine.png)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "repeat",
  },
  card: {
    maxWidth: "520px",
    width: "100%",
    textAlign: "center",
    background: "#ffffff",
    borderRadius: "12px",
    padding: "40px 32px",
    boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
  },
  icon: { fontSize: "56px", marginBottom: "16px" },
  title: { fontSize: "22px", fontWeight: 700, color: "#0d59b2", margin: "0 0 16px" },
  message: {
    fontSize: "15px",
    color: "#333333",
    whiteSpace: "pre-line",
    lineHeight: 1.6,
    margin: 0,
  },
};

export default Maintenance;
